export enum eFavoriteType {
  ROUTES = 'routes',
  ADDRESSES = 'addresses',
  LINES = 'lines',
  STATIONS = 'stations',
  HOME_ADDRESS = 'home_address',
  WORK_ADDRESS = 'work_address',
  LAST_SEARCH = 'last_search',
}
